import http from "@/helper/http";

const defaultPagination = () => ({
  page: 1,
  perPage: 20,
  total: 0,
  totalPages: 1,
});

const initialState = () => ({
  userItems: [],
  userPagination: defaultPagination(),
  userLoading: false,
  userActionLoadingId: null,
  storeItems: [],
  storePagination: defaultPagination(),
  storeLoading: false,
  storeActionLoadingId: null,
});

export default {
  namespaced: true,
  state: initialState(),
  mutations: {
    SET_USER_LOADING(state, loading) {
      state.userLoading = loading;
    },
    SET_USERS(state, { items, pagination }) {
      state.userItems = items || [];
      state.userPagination = {
        ...state.userPagination,
        ...pagination,
      };
    },
    SET_USER_ACTION_LOADING(state, id) {
      state.userActionLoadingId = id;
    },
    SET_STORE_LOADING(state, loading) {
      state.storeLoading = loading;
    },
    SET_STORES(state, { items, pagination }) {
      state.storeItems = items || [];
      state.storePagination = {
        ...state.storePagination,
        ...pagination,
      };
    },
    SET_STORE_ACTION_LOADING(state, id) {
      state.storeActionLoadingId = id;
    },
    RESET_STATE(state) {
      Object.assign(state, initialState());
    },
  },
  actions: {
    async fetchUsers({ commit }, { page, perPage, search, verified }) {
      commit("SET_USER_LOADING", true);
      try {
        const params = { page, per_page: perPage };
        if (search) params.search = search;
        if (verified && verified !== "all") params.verified = verified;

        const response = await http.get("/v1/admin/email-verification/users", {
          params,
        });
        const payload = response?.data || {};
        const pagination = {
          page: payload.page ?? page,
          perPage: payload.per_page ?? perPage,
          total: payload.total ?? payload.total_items ?? 0,
          totalPages: payload.total_pages ?? payload.pages ?? 1,
        };
        commit("SET_USERS", {
          items: Array.isArray(payload.items) ? payload.items : [],
          pagination,
        });
      } finally {
        commit("SET_USER_LOADING", false);
      }
    },
    async fetchStores({ commit }, { page, perPage, search, verified }) {
      commit("SET_STORE_LOADING", true);
      try {
        const params = { page, per_page: perPage };
        if (search) params.search = search;
        if (verified && verified !== "all") params.verified = verified;

        const response = await http.get("/v1/admin/email-verification/stores", {
          params,
        });
        const payload = response?.data || {};
        const pagination = {
          page: payload.page ?? page,
          perPage: payload.per_page ?? perPage,
          total: payload.total ?? payload.total_items ?? 0,
          totalPages: payload.total_pages ?? payload.pages ?? 1,
        };
        commit("SET_STORES", {
          items: Array.isArray(payload.items) ? payload.items : [],
          pagination,
        });
      } finally {
        commit("SET_STORE_LOADING", false);
      }
    },
    async requestUserVerification({ commit }, userId) {
      commit("SET_USER_ACTION_LOADING", userId);
      try {
        const response = await http.post(
          `/v1/admin/email-verification/users/${userId}/request`
        );
        return response?.data || null;
      } finally {
        commit("SET_USER_ACTION_LOADING", null);
      }
    },
    async requestStoreVerification({ commit }, storeId) {
      commit("SET_STORE_ACTION_LOADING", storeId);
      try {
        const response = await http.post(
          `/v1/admin/email-verification/stores/${storeId}/request`
        );
        return response?.data || null;
      } finally {
        commit("SET_STORE_ACTION_LOADING", null);
      }
    },
    async updateUserEmail(_, { userId, email }) {
      const response = await http.put(
        `/v1/admin/email-verification/users/${userId}/email`,
        { email }
      );
      return response?.data || null;
    },
    async updateStoreEmail(_, { storeId, email }) {
      const response = await http.put(
        `/v1/admin/email-verification/stores/${storeId}/email`,
        { email }
      );
      return response?.data || null;
    },
    async removeUserEmail(_, userId) {
      const response = await http.delete(
        `/v1/admin/email-verification/users/${userId}/email`
      );
      return response?.data || null;
    },
    async removeStoreEmail(_, storeId) {
      const response = await http.delete(
        `/v1/admin/email-verification/stores/${storeId}/email`
      );
      return response?.data || null;
    },
  },
  getters: {
    userItems: (state) => state.userItems,
    userPagination: (state) => state.userPagination,
    userLoading: (state) => state.userLoading,
    userActionLoadingId: (state) => state.userActionLoadingId,
    storeItems: (state) => state.storeItems,
    storePagination: (state) => state.storePagination,
    storeLoading: (state) => state.storeLoading,
    storeActionLoadingId: (state) => state.storeActionLoadingId,
  },
};
